<template>
  <b-overlay
    :show="__isOnLoad"
    variant="white"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
    id="facture"
    class="print-sheet"
    style="float: left; width: 100%"
  >
      <div class="print-document">
        <b-button class="printBtn" size="sm" variant="" @click="__.printMe('facture');"><b-icon icon="printer" scale="1" variant="info"></b-icon> Imprimer</b-button>

        <div class="print-main">
          <div class="row headerP">
            <div class="col-md-3 logoP"><img
            :src="require('@/assets/img/itteclogo.png')"
            alt=""
            style="height: 120px; float: left"
          /></div>
            <div class="col-md-4"></div>
            <div class="col-md-5 steP" style="text-align: right"><RecapSte :__ID="ownerId" :__inFacture="true"> </RecapSte>
              <br /><br />
            <b style="float: right">Tunis, {{__._getDate(__object.createdAt)}}</b>
            </div>
          </div>

          <div class="row"><div class="col-md-12"><h1 class="printDocumentTitle">{{ documentTitle }}</h1></div></div>
          <div class="row" v-if="__object.parentInf"><div class="col-md-12"><h1 class="printParentInfo">{{__object.parentInf}}</h1></div></div>

          <div class="row" v-if="__object.moreinfo"><div class="col-md-12"><b class="printMoreInfo">{{__object.moreinfo}}</b></div></div>

          <div class="row ligne printTableRow printTableHead">
            <div class="col-md-2 dataCel dataCel-label">
              <b class="printStructureLabel"><span class="printLabelStrong">Référence</span></b>
            </div>

            <div :class="showFinancialColumns ? 'col-md-3 dataCel dataCel-label' : 'col-md-9 dataCel dataCel-label'">
              <b class="printStructureLabel"><span class="printLabelStrong">Désignation</span></b>
            </div>

            <div class="col-md-1 dataCel dataCel-label">
              <b class="printStructureLabel"><span class="printLabelStrong">Qte</span></b>
            </div>

            <div class="col-md-2 dataCel dataCel-label" v-if="showFinancialColumns">
              <b class="printStructureLabel"><span class="printLabelStrong">Prix HT</span></b>
            </div>

            <div class="col-md-1 dataCel dataCel-label" v-if="showFinancialColumns">
              <b class="printStructureLabel"><span class="printLabelStrong">Remise</span></b>
            </div>

            <div class="col-md-3 dataCel dataCel-label" v-if="showFinancialColumns">
              <b class="printStructureLabel"><span class="printLabelStrong">Total HT</span></b>
            </div>
          </div>

          <div
            v-for="(item, index) in filteredItems"
            :key="index"
            class="row ligne printTableRow"
          >
            <div class="col-md-2 dataCel">
              {{item.ref}}
            </div>

            <div :class="showFinancialColumns ? 'col-md-3 dataCel' : 'col-md-9 dataCel'" style="text-align: left">
              {{ item.name }}
            </div>

            <div class="col-md-1 dataCel">
              {{item.qte}}
            </div>

            <div class="col-md-2 dataCel" v-if="showFinancialColumns" style="text-align: right">
              {{formatMoney(item.prix)}}
            </div>

            <div class="col-md-1 dataCel" v-if="showFinancialColumns">
              {{item.remise}} %
            </div>

            <div class="col-md-3 dataCel" v-if="showFinancialColumns" style="text-align: right">
              {{formatMoney(calculatePriceProd(item))}}
            </div>
          </div>

          <div class="row ligne printTableRow" v-if="showFinancialColumns">
            <div class="col-md-6 emptydataCel">
              &nbsp;
            </div>
            <div class="col-md-3 dataCel dataCel-summaryLabel" style="text-align: right">
              <b class="printStructureLabel"><span class="printLabelStrong">Total HT :</span></b>
            </div>

            <div class="col-md-3 dataCel dataCel-summaryValue" style="text-align: right">
              {{formatMoney(calculatePriceAllHT())}}
            </div>
          </div>

          <div class="row ligne printTableRow" v-if="showFinancialColumns">
            <div class="col-md-6 emptydataCel">
              &nbsp;
            </div>

            <div class="col-md-3 dataCel dataCel-summaryLabel" style="text-align: right">
              <b class="printStructureLabel"><span class="printLabelStrong">TVA {{__object.tva}}% :</span></b>
            </div>

            <div class="col-md-3 dataCel dataCel-summaryValue" style="text-align: right">
              {{formatMoney(__object.totalTVA)}}
            </div>
          </div>

          <div class="row ligne printTableRow" v-if="showStamp">
            <div class="col-md-6 emptydataCel">
              &nbsp;
            </div>

            <div class="col-md-3 dataCel dataCel-summaryLabel" style="text-align: right">
              <b class="printStructureLabel"><span class="printLabelStrong">Timbre :</span></b>
            </div>

            <div class="col-md-3 dataCel dataCel-summaryValue" style="text-align: right">
              {{formatMoney(stampAmount)}}
            </div>
          </div>

          <div class="row ligne printTableRow" v-if="showFinancialColumns">
            <div class="col-md-6 emptydataCel">
              &nbsp;
            </div>

            <div class="col-md-3 dataCel dataCel-summaryLabel" v-if="showFinancialColumns" style="text-align: right">
              <b class="printStructureLabel"><span class="printLabelStrong">Montant TTC :</span></b>
            </div>

            <div class="col-md-3 dataCel dataCel-summaryValue" style="text-align: right">
              {{formatMoney(documentTotalTTC)}}
            </div>
          </div>
        </div>

        <div class="print-bottom">
          <div class="amountSummary" style="border: solid 1px #000; padding: 20px; font-size: 13px; margin:10px" v-if="showFinancialColumns">
            <b class="amountSummaryLabel"><span class="printLabelStrong">{{closingText}}</span><br></b>
            <span class="amountSummaryValue">{{__.amountToWords(Number(documentTotalTTC || 0))}}</span>
          </div>

          <div class="moreDetailBlock" v-if="__object.moreDetail">
            {{__object.moreDetail}}
          </div>

          <div class="signatureBlock" style=" font-size: 12px; margin:10px">
          Meilleures salutations<br>
            <b>{{assignedTo.name}}</b><br>
            {{assignedTo.post}}
          </div>

          <div class="legalFooter" style="text-align:center; font-size:11px; color:#ccc">
            1, rue l’usine ZI Charguia II 2035 Tunis Carthage<br>
    CC: Banque de Tunisie BT EL MENZAH 8 , ALLEE DE L ARIANA titulaire du compte n°05003000007320219171<br>
    Code TVA: 000MA587628 P | RC: D24266497 | Code en Douane: 0587628 P<br>
          </div>
        </div>
      </div>
  </b-overlay>
</template>
<script>
import RecapSte from '@/pages/societes/RecapStatic';
  export default {
    components: {
      RecapSte
    },
    props: {
        __object: {
        type: Object,
        default: () => {
          return {};
        },
      },

      __isOnLoad: {
        type: Boolean,
        default: () => {
          return false;
        },
      },
    },

    data() {
      return {
        onGoingReq: [],
        errorCtrl: []
      };
    },
    methods: {
      calculatePriceProd(itm) {
        var prix = Number(itm.prix || 0) * Number(itm.qte || 0);

        var cof = 1;
        if(Number(itm.remise) > 0) {
          var remise = 100 - Number(itm.remise);
          cof = remise / 100;
        }
        itm.total = (prix * cof).toFixed(3);
        return itm.total
      },

      calculatePriceAllHT() {
        var solde  = 0;
        var cof = 0;
        if( this.$props.__object.tva !== '') {
          cof = Number(this.$props.__object.tva || 0) / 100
        }
        this.filteredItems.map(e => {
          if(e.isValide)
            solde += Number(e.total || this.calculatePriceProd(e))
        })
        this.$props.__object.totalHT = solde.toFixed(3);
        this.$props.__object.totalTVA = (solde*cof).toFixed(3);
        this.$props.__object.totalTTC = (
          solde +
          (solde * cof) +
          this.stampAmount
        ).toFixed(3)
        return this.$props.__object.totalHT;
      },

      formatMoney(value) {
        const amount = Number(value || 0);
        return amount.toFixed(3);
      },

      getTof(c) {
        return this.__.resolveMediaPath(c, "uploads/societes/No-Image.jpg");
      },

      RemoveFromBasket(id) {
        this.$props.__object.devis = this.$props.__object.devis.filter((e) => e.id !== id);
    },
    },
    watch: {
      __isOnLoad: function () {},
     
    },
    computed: {
      assignedTo() {
        return this.$props.__object.assignedTo || {};
      },

      showFinancialColumns() {
        return this.$props.__object.type !== 'BON DE LIVRAISON';
      },

      showStamp() {
        return this.$props.__object.type === 'FACTURE';
      },

      stampAmount() {
        return this.showStamp ? 1 : 0;
      },

      documentTotalTTC() {
        const totalHT = Number(this.$props.__object.totalHT || 0);
        const totalTVA = Number(this.$props.__object.totalTVA || 0);

        return (totalHT + totalTVA + this.stampAmount).toFixed(3);
      },

      closingText() {
        const labels = {
          'Facture Proformat': 'Arrêtée la présente facture pro forma à la somme de :',
          DEVIS: 'Arrêté le présent devis à la somme de :',
          COMMANDE: 'Arrêtée la présente commande à la somme de :',
          FACTURE: 'Arrêtée la présente facture à la somme de :',
          AVOIR: "Arrêté le présent avoir à la somme de :",
        };

        return labels[this.$props.__object.type] || 'Arrêté le présent document à la somme de :';
      },

      ownerId() {
        return this.$props.__object.owner ? this.$props.__object.owner.pid : "";
      },

      documentTitle() {
        const typeLabel = this.$props.__object.type || "DOCUMENT";
        const exercice = this.$props.__object.exercice || "";
        const num = this.$props.__object.num;

        if (num !== undefined && num !== null && num !== "") {
          return `${typeLabel} N° ${num} / ${exercice}`;
        }

        return `${typeLabel} - BROUILLON${exercice ? ` / ${exercice}` : ""}`;
      },

      filteredItems() {
        const devis = Array.isArray(this.$props.__object.devis)
          ? this.$props.__object.devis
          : [];

        return devis.filter((item) => {
          if (this.$props.__object.type !== 'BON DE LIVRAISON') {
            return item.isValide;
          }

          return item.isValide && item.type === 'PRD';
        });
      },
    },
    mounted() {
      
    },
  };
</script>
<style scoped>
.print-sheet {
  background: #fff;
  color: #000;
  padding: 24px;
}

.print-document {
  min-height: auto;
  display: flex;
  flex-direction: column;
}

.print-main {
  width: 100%;
}

.print-main .row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.printTableRow {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
}

.printTableRow > [class*="col-md-"] {
  box-sizing: border-box;
  padding-left: 0;
  padding-right: 0;
  min-width: 0;
}

.printDocumentTitle {
  text-align: center;
  text-transform: uppercase;
  font-size: 31px;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: #111827;
  margin: 8px 0 4px;
}

.printParentInfo {
  font-size: 14px;
  font-weight: 700;
  color: #2d3748;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin: 0 0 8px;
}

.printMoreInfo {
  display: inline-block;
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
  margin-top: 10px;
}

.dataCel {
  box-sizing: border-box;
  border: solid 1px #999;
  text-align: center;
  font-size: 11px;
  padding: 6px 8px;
  overflow: hidden;
}

.dataCel-label {
  background: #eaf0fb;
  color: #102a56;
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.dataCel-summaryLabel {
  background: #f3f4f6;
  color: #111827;
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
}

.dataCel-summaryValue {
  font-size: 13px;
  font-weight: 700;
  color: #111827;
}

.amountSummaryLabel {
  display: inline-block;
  margin-bottom: 6px;
  font-size: 16px;
  font-weight: 800;
  text-transform: uppercase;
  color: #111827;
}

.amountSummaryValue {
  display: inline-block;
  font-size: 14px;
  line-height: 1.5;
  color: #1f2937;
}

.printLabelStrong {
  display: inline-block;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 900 !important;
  letter-spacing: 0.03em;
}

.printStructureLabel {
  display: inline-block;
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 900 !important;
  line-height: 1.05;
}
  .item {
    padding: 10px;
    border-radius: 10px;
    background-color: #eee;
    color: #000;
    font-size: 10px;
    margin-bottom: 10px;
    margin-right:1px !important;
    margin-left:1px !important;
  }
  .pic {
    width: 80px;
    float: left;
    margin-right: 10px;
  }
  h1 {
    font-size: 20px;
    color: #000;
  }
  h3 {
    font-size: 10px;
    color: #000;
  }
  .history {
    float: right;
    color: #000;
    font-size: 12px;
  }
  .emptydataCel {
    color: transparent;
  }
  .print-bottom {
    margin-top: 14px;
    padding-top: 14px;
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .amountSummary,
  .moreDetailBlock,
  .signatureBlock,
  .legalFooter {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .legalFooter {
    margin-top: 18px;
  }

  @media print {
    .printDocumentTitle {
      font-size: 28px;
    }

    .printParentInfo,
    .printMoreInfo,
    .dataCel-label,
    .dataCel-summaryLabel,
    .dataCel-summaryValue,
    .amountSummaryLabel,
    .amountSummaryValue,
    .printLabelStrong,
    .printStructureLabel {
      color: #000 !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    .dataCel-label,
    .dataCel-summaryLabel,
    .amountSummaryLabel,
    .printLabelStrong,
    .printStructureLabel {
      font-family: Arial, Helvetica, sans-serif !important;
      font-weight: 900 !important;
    }

    .print-document {
      min-height: auto;
    }

    .printTableRow {
      display: flex;
      flex-wrap: nowrap;
      margin-left: 0 !important;
      margin-right: 0 !important;
    }

    .printTableRow > [class*="col-md-"] {
      box-sizing: border-box;
      padding-left: 0;
      padding-right: 0;
      min-width: 0;
    }

    .dataCel {
      box-sizing: border-box;
      overflow: hidden;
    }

    .print-bottom {
      margin-top: 14px;
      padding-top: 14px;
    }

    .print-bottom {
      padding-bottom: 12mm;
    }

    .legalFooter {
      position: fixed;
      left: 12mm;
      right: 12mm;
      bottom: 2mm;
      margin-top: 0;
      padding-top: 4mm;
      background: #fff;
    }
  }
</style>
